































































import Vue from 'vue';
import { awsS3URL } from '../../utils/constants';

export default Vue.extend({
  name: 'PacienteConsultaColetivaMiniCard',
  props: {
    paciente: {
      type: Object,
      default: null,
    },
    dentroDoModal: {
      default: false,
    },
    layout: {
      default: 'horizontal',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    fotoURL() {
      return this.paciente.foto_aws_key ? `${awsS3URL}${this.paciente.foto_aws_key}` : null;
    },
  },
});
